export const ALGOLIA_FAMILY_CODE_MACBOOK = 'bb_macbook'
export const ALGOLIA_FAMILY_CODE_SMARTPHONE = 'bb_smartphone'
export const ALGOLIA_FAMILY_CODE_AUDIO = 'bb_audio'
export const ALGOLIA_FAMILY_CODE_CONSOLE = 'bb_gaming_console'
export const ALGOLIA_OTHER_FAMILIES = 'default'

export type FamilyCode =
  | typeof ALGOLIA_FAMILY_CODE_MACBOOK
  | typeof ALGOLIA_FAMILY_CODE_SMARTPHONE
  | typeof ALGOLIA_FAMILY_CODE_AUDIO
  | typeof ALGOLIA_FAMILY_CODE_CONSOLE
  | typeof ALGOLIA_OTHER_FAMILIES

export type AttributesType = Record<string, Record<string, string | number>>
export type FacetType = Record<string, number>
export type FacetsType = Record<string, FacetType>

export type AlgoliaHit = {
  uuid: string
  familyCode: FamilyCode
  family: string
  objectID: string
  markets: string[]
  image: string | null
  attributes: AttributesType
}

export interface BuyBackProducts {
  hits: AlgoliaHit[]
  page: number
  nbPages: number
  nbHits: number
  hitsPerPage: number
  facets: FacetsType
}
